<template>
  <div>
    <div class="row">
      <div class="col-12 ">
        <div class="card child-card p-0 d-flex pt-5">
          <div class="card-header h-20 d-flex">
            <img :src="currentCard.image" class="img-fluid" />
          </div>
          <div class="card-body ">
            <div class="card-title child-title title-container">{{ currentCard.name }}</div>
            <get-started class="mt-2" :cardId="currentCard.id"></get-started>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CardHelperMixin from "@/components/homepage/mixins/CardHelperMixin";
import GetStarted from "@/components/homepage/GetStarted"
export default {
  mixins: [CardHelperMixin],
  components:{
    GetStarted
  }
};
</script>

<style scoped>
.title-container{
  max-height: 85px;
  min-height: 85px;
  margin-bottom: 5px;
  overflow: hidden;
}

.img-fluid {
  width: 90px !important;
  height: 92px !important;
  align-items: center !important;
}

</style>